<ng-container *ngIf="state">
  <!-- Dimming backdrop with a spotlight cut-out around the highlighted element.
       Clicking the backdrop intentionally does nothing: the tour can only be dismissed via the
       Skip or Done/Next buttons, so an accidental outside click never closes it. -->
  <div class="guided-tour__backdrop"
       [class.guided-tour__backdrop--no-spotlight]="!spotlight"></div>

  <div class="guided-tour__spotlight"
       *ngIf="spotlight"
       [style.top.px]="spotlight.top"
       [style.left.px]="spotlight.left"
       [style.width.px]="spotlight.width"
       [style.height.px]="spotlight.height"></div>

  <!-- Step popover -->
  <div class="guided-tour__popover"
       [ngClass]="'guided-tour__popover--arrow-' + popover.arrow"
       [style.top.px]="popover.top"
       [style.left.px]="popover.left">
    <div class="guided-tour__title">{{ state.step.titleKey | translate }}</div>
    <div class="guided-tour__text">{{ state.step.textKey | translate }}</div>

    <div class="guided-tour__footer">
      <span class="guided-tour__progress">{{ state.index + 1 }} / {{ state.total }}</span>
      <span class="guided-tour__actions">
        <button type="button" class="btn btn-xs btn-plain-primary guided-tour__skip" (click)="skip()">
          {{ 'GUIDED_TOUR.skip' | translate }}
        </button>
        <button type="button" class="btn btn-xs btn-plain-default" *ngIf="!state.isFirst" (click)="previous()">
          {{ 'GUIDED_TOUR.back' | translate }}
        </button>
        <button type="button"
                class="btn btn-xs"
                [ngClass]="state.isLast ? 'btn-primary' : 'btn-fill-default'"
                (click)="next()">
          {{ (state.isLast ? 'GUIDED_TOUR.done' : 'GUIDED_TOUR.next') | translate }}
        </button>
      </span>
    </div>
  </div>
</ng-container>

